import { dispatchCustomEvent } from '../../../utils/dispatch';
import ModalBtn from '../../molecules/modalButton/view';

import ThirdsTable from '../thirdsTable/view';

function ThirdsModal({ id, type, hidden = false }) {

    function lable() {
        if (type == "provider") {
            return "Proveedores"
        }
        return "Clientes"
    }

    return (
        <ModalBtn
            id={id ? "modal-third-" + id : "modal-third"}
            title={lable()}
            hidden={hidden}
        >
            <ThirdsTable
                id={id ? "modal-third-" + id : "modal-third"}
                forceLoadData={true}
                type={type ? type : "client"}
            />
        </ModalBtn>
    )
}

export default ThirdsModal
